module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Book-5dfc0c9ebfced1a0283e0c267ebc4da0.eot";